import { useUIColors } from '@/core/hooks';
import React from 'react';
import { StyleSheet, View, ViewProps } from 'react-native';

export interface ProgressBarProps extends Omit<ViewProps, 'style'> {
    progress: number; // 0..1
    color?: string; // color for the progress fill (defaults to vectorsIconGreyscale)
    style?: ViewProps['style'];
}

export const ProgressBar = React.memo<ProgressBarProps>(function ProgressBar({ progress, color, style, ...props }) {
    const colors = useUIColors();
    const clamped = Math.max(0, Math.min(1, progress || 0));
    const fillColor = color || colors.vectorsIconGreyscale;

    return (
        <View style={[styles.container, { backgroundColor: colors.backgroundLevel2 }, style]} {...props}>
            <View style={[styles.fill, { width: `${clamped * 100}%`, backgroundColor: fillColor }]} />
        </View>
    );
});

const styles = StyleSheet.create({
    container: {
        height: 8, // Figma: 8px height
        borderRadius: 4, // Figma: 4px radius
        overflow: 'hidden',
        width: 220, // Figma: fixed 220px width
        maxWidth: 220, // Ensure it doesn't exceed Figma width
    },
    fill: {
        height: '100%',
    },
});

export default ProgressBar;


